import api from '../api/subsidiaries'
import apiDirectors from '../api/directors'
import apiBrokers from '../api/brokers'
import apiProperties from '../api/properties'
import apiNews from '../api/news'
import apiImi from '../api/imi'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'sucursal/RECEIVE_DIRECTORS',
  RECEIVE_BROKERS: 'sucursal/RECEIVE_BROKERS',
  RECEIVE_NEWS: 'sucursal/RECEIVE_NEWS',
  RECEIVE_IMIS: 'RECEIVE_IMIS',
  RECEIVE_OPERATION_TYPES: 'sucursal/RECEIVE_OPERATION_TYPES,',
  RECEIVE_SUBSIDIARY_TYPES: 'sucursal/RECEIVE_SUBSIDIARY_TYPES',
  RECEIVE_NORDELTA: 'sucursal/RECEIVE_NORDELTA',
  RECEIVE_CENTRO: 'sucursal/RECEIVE_CENTRO',
  RECEIVE_SANISIDRO: 'sucursal/RECEIVE_SANISIDRO',
  RECEIVE_PUERTOS: 'sucursal/RECEIVE_PUERTOS',
  RECEIVE_PALERMO: 'sucursal/RECEIVE_PALERMO',
  RECEIVE_SUBSIDIARIES_LIST: 'sucursal/RECEIVE_SUBSIDIARIES_LIST',
  RECEIVE_PILAR: 'sucursal/RECEIVE_PILAR',
  RECEIVE_ESCOBAR: 'sucursal/RECEIVE_ESCOBAR',
}

export const loadDirectorsBySector = (id) => {
  return(dispatch, getStore) => {
    apiDirectors.fetchDirectorsBySector(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadBrokersBySector = (id) => {
  return(dispatch, getStore) => {
    apiBrokers.fetchBrokers(id)
      .then((data) => dispatch(receiveBrokers(data)))
  }
}

function receiveBrokers(APIdata) {
  return {
    type: actionTypes.RECEIVE_BROKERS,
    data: APIdata.data
  }
}

export const getOperationTypes = (value) => {
  return(dispatch) => {
    apiProperties.fetchOperationTypesBySection(value)
      .then((data) => dispatch(receiveOperationTypes(data)))
      .catch(console.error)
  }
}

function receiveSectors (data) {
  let arraySectors = data.data
  let sector = arraySectors.filter(function (d) {
    return d.name === 'viviendas - nordelta'
  })
  let id = sector[0].id
  return(dispatch) => {
    apiProperties.fetchOperationTypes(id)
      .then((data) => dispatch(receiveOperationTypes(data)))
      .catch(console.error)
  }
}

export const receiveOperationTypes = (operations) => {
  return {
    type: actionTypes.RECEIVE_OPERATION_TYPES,
    operations
  }
}

export const loadSubsidiaryTypes = () => {
  return(dispatch, getStore) => {
    apiProperties.fetchSubsidiaryTypes()
      .then((data) => dispatch(receiveSubsidiaryTypes(data)))
			.catch(console.error)
  }
}

export const receiveSubsidiaryTypes = (data) => {
  return {
    type: actionTypes.RECEIVE_SUBSIDIARY_TYPES,
    data
  }
}

export const loadNewsBySector = (id) => {
  return(dispatch, getStore) => {
    apiNews.fetchNewsBySector(id)
      .then((data) => dispatch(receiveNews(data)))
  }
}

function receiveNews(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEWS,
    data: APIdata
  }
}

export const loadImisBySector = (id) => {
  return(dispatch, getStore) => {
    apiImi.fetchImisBySector(id)
      .then((data) => dispatch(receiveImis(data)))
  }
}

function receiveImis(APIdata) {
  return {
    type: actionTypes.RECEIVE_IMIS,
    data: APIdata.data
  }
}

export const loadRelevantProperties = (category_type) => {
  return(dispatch) => {
    // lo hago secuencial porque la apiProperties solo permite que haya una query a la vez en la red
		apiProperties.fetchSubsidiaryTypes()
      .then((types) => {
				apiProperties
					.fetchRelevantProperties(6, types.filter(obj => obj.name == 'sanisidro')[0].id)
					.then((data) => dispatch(receiveSanIsidro(data)))
					.catch(console.error)
					.then(()=>{
						apiProperties
						.fetchRelevantProperties(6, types.filter(obj => obj.name == 'nordelta')[0].id)
						.then((data) => dispatch(receiveNordelta(data)))
						.catch(console.error)
						.then(()=>{
							apiProperties
							.fetchRelevantProperties(6, types.filter(obj => obj.name == 'centro')[0].id)
							.then((data) => {
								dispatch(receiveCentro(data))
								dispatch(receivePalermo(data))
							})
							.catch(console.error)
							.then(()=>{
								apiProperties
								.fetchRelevantProperties(6, types.filter(obj => obj.name == 'puertos')[0].id)
								.then((data) => dispatch(receivePuertos(data)))
								.catch(console.error)
                .then(() => {
                  apiProperties
                  .fetchRelevantProperties(6, types.filter(obj => obj.name == 'pilar')[0].id)
                  .then((data) => dispatch(receivePilar(data)))
                  .catch(console.error)
                  .then(() => {
                    apiProperties
                      .fetchRelevantProperties(6, types.filter(obj => obj.name == 'escobar')[0].id)
                      .then((data) => dispatch(receiveEscobar(data)))
                      .catch(console.error)
                  })
                })
							})
						})
					})
			})
  }
}

function receiveNordelta(APIdata) {
  return {
    type: actionTypes.RECEIVE_NORDELTA,
    data: APIdata.data
  }
}

function receiveCentro(APIdata) {
  return {
    type: actionTypes.RECEIVE_CENTRO,
    data: APIdata.data
  }
}

function receiveSanIsidro(APIdata) {
  return {
    type: actionTypes.RECEIVE_SANISIDRO,
    data: APIdata.data
  }
}

function receivePuertos(APIdata) {
  return {
    type: actionTypes.RECEIVE_PUERTOS,
    data: APIdata.data
  }
}

function receivePilar(APIdata) {
  return {
    type: actionTypes.RECEIVE_PILAR,
    data: APIdata.data,
  }
}

function receiveEscobar(APIdata) {
  return {
    type: actionTypes.RECEIVE_ESCOBAR,
    data: APIdata.data,
  }
}

function receivePalermo(APIdata) {
  return {
    type: actionTypes.RECEIVE_PALERMO,
    data: APIdata.data
  }
}

export const loadSubsidiariesList = () => {
  return(dispatch, getStore) => {
    api.fetchSubsidiaries()
      .then((data) => dispatch(receiveSubsidiaries(data)))
			.catch(console.error)
  }
}

export const receiveSubsidiaries = (APIdata) => {
  return {
    type: actionTypes.RECEIVE_SUBSIDIARIES_LIST,
    data: APIdata.data
  }
}



// WEBPACK FOOTER //
// ./src/actions/subsidiaries.js